import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHeader } from '../components/PageHeader';
import { ImpactSection } from '../components/ImpactSection';
import { SEO } from '../components/SEO';
import { TrendingUp, Users, Heart, Award } from 'lucide-react';
export function ImpactPage() {
  const impactStats = [{
    icon: <Users className="w-10 h-10" data-id="element-732" />,
    number: '10,000+',
    label: 'Lives Touched',
    description: 'Individuals directly benefiting from our programs',
    color: 'bg-primary'
  }, {
    icon: <Heart className="w-10 h-10" data-id="element-733" />,
    number: '50+',
    label: 'Communities Served',
    description: 'Across multiple states in Nigeria',
    color: 'bg-accent'
  }, {
    icon: <TrendingUp className="w-10 h-10" data-id="element-734" />,
    number: '85%',
    label: 'Success Rate',
    description: 'Of beneficiaries achieving sustainable improvement',
    color: 'bg-secondary'
  }, {
    icon: <Award className="w-10 h-10" data-id="element-735" />,
    number: '6',
    label: 'Focus Areas',
    description: 'Comprehensive approach to community development',
    color: 'bg-primary'
  }];
  return <div className="font-sans bg-warm-ivory min-h-screen w-full" data-id="element-736">
      <SEO title="Our Impact - SFRR Foundation" description="See the measurable difference SFRR Foundation is making in communities across Nigeria. Real stories, real impact, real transformation." keywords="SFRR impact, community transformation Nigeria, nonprofit results, development impact, success stories Nigeria" data-id="element-737" />

      <Header data-id="element-738" />
      <main className="w-full font-sans" data-id="element-739">
        <PageHeader title="Our Impact" subtitle="Measuring the difference we make in communities across Nigeria" badgeText="IMPACT" backgroundImage="https://cdn.magicpatterns.com/uploads/f7ESkRq73fhGmwWiuULtnK/SFRR_Foundation_(3).jpg" data-id="element-740" />

        {/* Impact Stats */}
        <section className="py-20 bg-white" data-id="element-741">
          <div className="container mx-auto px-4" data-id="element-742">
            <div className="max-w-6xl mx-auto" data-id="element-743">
              <div className="text-center mb-16" data-id="element-744">
                <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-4" data-id="element-745">
                  By The Numbers
                </span>
                <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-6" data-id="element-746">
                  Creating Measurable Change
                </h2>
                <p className="text-lg text-neutral-600 max-w-3xl mx-auto" data-id="element-747">
                  Our commitment to transparency means tracking and sharing the
                  real impact of our work
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-748">
                {impactStats.map((stat, index) => <div key={index} className="bg-warm-ivory rounded-2xl p-8 text-center shadow-soft hover:shadow-hover transition-all duration-300 hover:-translate-y-1 animate-fadeInUp" style={{
                animationDelay: `${index * 100}ms`
              }} data-id="element-749">
                    <div className={`w-16 h-16 rounded-xl ${stat.color} bg-opacity-10 flex items-center justify-center mx-auto mb-6`} data-id="element-750">
                      <div className={`${stat.color.replace('bg-', 'text-')}`} data-id="element-751">
                        {stat.icon}
                      </div>
                    </div>
                    <div className="text-4xl font-bold text-charcoal mb-2" data-id="element-752">
                      {stat.number}
                    </div>
                    <div className="text-lg font-semibold text-charcoal mb-2" data-id="element-753">
                      {stat.label}
                    </div>
                    <p className="text-sm text-neutral-600" data-id="element-754">
                      {stat.description}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </section>

        <ImpactSection data-id="element-755" />

        {/* Call to Action */}
        <section className="py-16 bg-gradient-to-br from-primary/5 to-secondary/5" data-id="element-756">
          <div className="container mx-auto px-4" data-id="element-757">
            <div className="max-w-3xl mx-auto text-center" data-id="element-758">
              <h2 className="text-3xl font-serif font-bold text-charcoal mb-6" data-id="element-759">
                Be Part of Our Impact
              </h2>
              <p className="text-lg text-neutral-600 mb-8" data-id="element-760">
                Join us in creating lasting change. Every contribution, big or
                small, makes a real difference.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-761">
                <a href="/donate" className="px-8 py-4 bg-primary text-white rounded-full font-semibold hover:bg-primary-600 transition-all duration-300 hover:-translate-y-0.5 shadow-md hover:shadow-lg" data-id="element-762">
                  Support Our Work
                </a>
                <a href="/stories" className="px-8 py-4 bg-white text-charcoal border-2 border-neutral-200 rounded-full font-semibold hover:border-primary hover:text-primary transition-all duration-300" data-id="element-763">
                  Read Success Stories
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-764" />
    </div>;
}